<script setup lang="ts">

const props = defineProps<{
  fieldKey: string
  value?: string
}>();

// const state = inject(stateContextKey);
// const enumFields = useEnumFields();
//
// if (!state) {
//   throw new Error('State context not found');
// }
//
// type Selected = {
//   type: 'value'
//   value: EnumFieldValue
// } | {
//   type: 'category',
//   category: EnumFieldCategory
//   categoryId: string
// };
//
// const selected = ref<Selected>();
// const addValueToCategory = ref<string>();
// const isAddingValue = ref(false);
// const newValue = ref('');
//
// if (props.value) {
//   const field = state.enumFields[props.fieldKey];
//   if (field) {
//     const preSelectedValue = field.values[props.value];
//    
//     if (preSelectedValue) {
//       selected.value = {
//         type: 'value',
//         value: preSelectedValue
//       };
//     }
//   }
// }
//
// export interface EnumFieldValueWithLabel extends EnumFieldValue {
//   label: ComputedRef<string>
// }
//
// const categories = computed(() => {
//   const field = state.enumFields[props.fieldKey];
//
//   const valuesPerCategory = new Map<string, EnumFieldValue[]>();
//  
//   for (const valueKey in field.values) {
//     const value = field.values[valueKey];
//     const categoryId = value.categoryId ?? 'none';
//    
//     let group = valuesPerCategory.get(categoryId);
//     if (!group) {
//       group = [];
//       valuesPerCategory.set(categoryId, group);
//     }
//
//     group.push(value);
//   }
//  
//   const result = [] as {
//     categoryId?: string
//     category?: EnumFieldCategory
//     values: EnumFieldValueWithLabel[]
//   }[];
//  
//   for (const categoryId in field.categories) {
//     result.push({
//       categoryId: categoryId,
//       category: field.categories[categoryId],
//       values: getLabels(valuesPerCategory.get(categoryId) ?? [])
//     });
//   }
//  
//   result.sort((a, b) => (a.category?.sortOrder ?? 0) - (b.category?.sortOrder ?? 0));
//  
//   result.push({
//     values: getLabels(valuesPerCategory.get('none') ?? [])
//   });
//  
//   function getLabels(values: EnumFieldValue[]) {
//     return values.map(r => {
//
//       const periodIdx = props.fieldKey.indexOf('.');
//
//       return {
//         ...r,
//         label: enumFields.valueLabel(
//           props.fieldKey.substring(0, periodIdx),
//           props.fieldKey.substring(periodIdx + 1),
//           r.value
//         )
//       } as EnumFieldValueWithLabel
//     }).sort((a, b) => {
//       const aNumber = parseInt(a.label.value);
//       const bNumber = parseInt(a.label.value);
//       if (!isNaN(aNumber) && !isNaN(bNumber)) {
//         return aNumber - bNumber;
//       }
//      
//       return a.label.value > b.label.value ? 1 : -1
//     });
//   }
//  
//   return result;
// });
//
// function selectValue(value: EnumFieldValue) {
//   selected.value = {
//     type: 'value',
//     value
//   };
// }
//
// function selectCategory(categoryId: string, category: EnumFieldCategory) {
//   selected.value = {
//     type: 'category',
//     category,
//     categoryId
//   };
// }
//
// function clearSelection() {
//   selected.value = undefined;
// }
//
// function addValue(categoryId?: string) {
//   addValueToCategory.value = categoryId;
//   isAddingValue.value = true;
// }
//
// function clearAddValue() {
//   addValueToCategory.value = undefined;
//   isAddingValue.value = false;
//   newValue.value = '';
// }



</script>

<template>
  <div class="editor-container">
    
<!--    <div class="categories">-->

<!--      <AddCategory :enum-field-key="fieldKey" />-->
<!--      -->
<!--      <div-->
<!--        v-for="entry in categories"-->
<!--        :key="entry.categoryId"-->
<!--        class="category"-->
<!--        :data-category="entry.categoryId"-->
<!--      >-->
<!--        -->
<!--        <div-->
<!--          class="category__header">-->
<!--          <span-->
<!--            v-if="entry.category && entry.categoryId"-->
<!--            @click="selectCategory(entry.categoryId, entry.category)"-->
<!--            class="category__label"-->
<!--            :class="{-->
<!--              'category__label&#45;&#45;selected': selected?.type === 'category' && selected.categoryId === entry.categoryId-->
<!--            }"-->
<!--          >-->
<!--            {{entry.category.name}}-->
<!--          </span>-->
<!--          <span v-else>Uncategorized</span>-->
<!--          -->
<!--          <div class="add-value" @click="addValue(entry.categoryId)">-->
<!--            <IconPlus />-->
<!--          </div>-->
<!--        </div>-->
<!--        -->
<!--        <AddValue-->
<!--          v-if="isAddingValue && addValueToCategory === entry.categoryId"-->
<!--          :field-key="fieldKey"-->
<!--          :category-id="entry.categoryId"-->
<!--          @close="clearAddValue"-->
<!--        />-->
<!--        -->
<!--        <ValueMenuItem-->
<!--          v-for="valueEntry in entry.values"-->
<!--          :key="valueEntry.value"-->
<!--          :field-key="props.fieldKey"-->
<!--          :field-value="valueEntry"-->
<!--          :field-label="valueEntry.label"-->
<!--          @click="selectValue(valueEntry)"-->
<!--          :class="{-->
<!--            'value&#45;&#45;selected': selected?.type === 'value' && selected.value.value === valueEntry.value-->
<!--          }"-->
<!--        />-->
<!--        -->
<!--      </div>-->
<!--      -->
<!--    </div>-->
<!--    -->
<!--    <PanelContent>-->
<!--      -->
<!--      <ValueEditor-->
<!--        v-if="selected?.type === 'value'"-->
<!--        :enum-field-value="selected.value"-->
<!--        :enum-field-key="fieldKey"-->
<!--        @removed="clearSelection"-->
<!--      />-->
<!--      -->
<!--      <CategoryEditor-->
<!--        v-else-if="selected?.type === 'category'"-->
<!--        :enum-field-category-id="selected.categoryId"-->
<!--        :enum-field-category="selected.category"-->
<!--        :enum-field-key="fieldKey"-->
<!--        @removed="clearSelection"-->
<!--      />-->
<!--      -->
<!--      <div v-else>-->
<!--        Select value or category to edit-->
<!--      </div>-->
<!--      -->
<!--    </PanelContent>-->
    
  </div>
  
</template>

<style scoped>

.editor-container {
  display: grid;
  grid-template-columns: 180px 400px;
  gap: 5px;
}

.category__header {
  font-weight: bold;
  text-transform: uppercase;
  font-size: .8em;
  color: hsl(var(--color-40));
  display: flex;
  justify-content: space-between;
}

.add-value {
  width: 16px;
  padding: 3px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.add-value:hover {
  background-color: hsl(var(--color-70));
  color: hsl(var(--color-20));
}

.value--selected {
  background-color: hsl(var(--color-80));
}

.category__label {
  cursor: pointer;
}

.category__label--selected {
  color: hsl(var(--color-20));
}

.category__label:hover {
  color: hsl(var(--color-20));
}

:deep(.add-value-input) {
  height: auto;
  padding: 2px .5em;
}

</style>